module.exports = require("skypager-util/lib/router");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/router"
// module id = 76
// module chunks = 0 1 2 3 4 5 6 7 10 11